export default "__VITE_ASSET__5f82daef__"